<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import DashboardSidebar from '@/components/core/sidebar/DashboardSidebar.vue';
import { Fold, Expand } from '@element-plus/icons-vue'

const route = useRoute()
const isCollapse = ref(false)

// 生成面包屑导航
const breadcrumbs = computed(() => {
  const matched = route.matched.filter(item => item.meta && item.meta.title)
  return matched.map((item, index) => ({
    title: item.meta?.title as string,
    path: item.path,
    isLast: index === matched.length - 1
  }))
})

const toggleSidebar = () => {
  isCollapse.value = !isCollapse.value
}
</script>

<template>
  <el-container class="h-screen">
    <el-aside :width="isCollapse ? '64px' : '256px'" class="transition-all duration-300 border-r">
      <DashboardSidebar :collapsed="isCollapse" />
    </el-aside>
    <el-container>
      <el-header class="flex h-16 shrink-0 items-center gap-2 px-4 border-b">
        <div class="flex items-center gap-2 flex-1">
          <el-button 
            :icon="isCollapse ? Expand : Fold" 
            @click="toggleSidebar"
            text
            class="-ml-1"
          />
          <el-divider direction="vertical" class="mr-2 h-4" />
          <el-breadcrumb class="hidden md:block">
            <el-breadcrumb-item 
              v-for="(crumb, index) in breadcrumbs" 
              :key="crumb.path"
              :to="crumb.isLast ? undefined : crumb.path"
            >
              {{ crumb.title }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="flex items-center gap-2">
          <!-- 可以在这里添加用户菜单等 -->
        </div>
      </el-header>
      <el-main class="flex flex-1 flex-col gap-4 p-4 overflow-auto">
        <RouterView v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" :key="route.fullPath"></component>
          </transition>
        </RouterView>
      </el-main>
    </el-container>
  </el-container>
</template>
